import React from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { RegistrationReviewItem } from '../../types/registrationReview.types';

const formatDate = (value: string | null) =>
  value
    ? new Date(value).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    : '';

type Props = {
  item: RegistrationReviewItem | null;
  submitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

function BusinessConfirmModal({ item, submitting, onCancel, onConfirm }: Props) {
  const alreadyNotified = !!item?.businessNoticeSentAt;

  return (
    <Modal show={!!item} onHide={submitting ? undefined : onCancel} centered>
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>Mark {item?.plateNumber} as Business?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          This plate is registered to a corporation. We will stop monitoring it, so no new tickets
          will be picked up or charged for.
        </p>

        {alreadyNotified ? (
          <Alert variant="secondary" className="mb-0">
            No message will be sent. {item?.clientName} was already told on{' '}
            {formatDate(item?.businessNoticeSentAt ?? null)}.
          </Alert>
        ) : (
          <Alert variant="warning" className="mb-0">
            <div className="fw-bold mb-1">
              {item?.clientName} will be told we can&apos;t fight tickets on this plate:
            </div>
            <div>
              Text: {item?.clientPhone || <span className="fst-italic">no phone on file</span>}
            </div>
            <div>
              Email: {item?.clientEmail || <span className="fst-italic">no email on file</span>}
            </div>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={submitting} autoFocus>
          {submitting ? (
            <Spinner animation="border" size="sm" />
          ) : alreadyNotified ? (
            'Mark Business'
          ) : (
            'Mark Business & notify client'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BusinessConfirmModal;
